import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// PrimeNG 20 needs a preset to resolve its surface and overlay tokens.
// Reuse the Intranet palette and its explicitly light color scheme.
export const intranetPrimeNgTheme = {
  preset: definePreset(Aura, {
    semantic: {
      focusRing: { color: 'var(--app-brand-600)' },
      colorScheme: {
        light: {
          primary: {
            color: 'var(--app-brand-600)',
            contrastColor: 'var(--app-bg-surface)',
            hoverColor: 'var(--app-brand-700)',
            activeColor: 'var(--app-brand-700)'
          },
          highlight: {
            background: 'var(--app-brand-50)',
            focusBackground: 'var(--app-brand-100)',
            color: 'var(--app-brand-700)',
            focusColor: 'var(--app-brand-700)'
          },
          content: {
            background: 'var(--app-bg-surface)',
            borderColor: 'var(--app-border-soft)',
            color: 'var(--app-text-primary)'
          }
        }
      }
    },
    components: {
      dialog: {
        root: {
          background: 'var(--app-bg-surface)',
          color: 'var(--app-text-primary)',
          borderColor: 'var(--app-border-soft)',
          borderRadius: 'var(--app-panel-radius)'
        }
      }
    }
  }),
  options: { darkModeSelector: false, cssLayer: false }
};
